import {FILTER_NAMES} from '../base.js'

const BODY_TYPE_GROUP_ID = 'bodyTypeGroup'
const COLOR_GROUP_ID = 'colorGroup'
const EQUIPMENT_GROUP_ID = 'equipmentGroup'
const ELECTRIC_GROUP_ID = 'electricGroup'
const ELECTRIC_CHARGING_TIME_GROUP_ID = 'electricChargingTimeGroup'
const KMS_GROUP_ID = 'kmsGroup'
const LOCATION_GROUP_ID = 'locationGroup'
const LOCATION_PLACES_GROUP_ID = 'locationPlacesGroup'
const MAKE_GROUP_ID = 'makeGroup'
const MOTOR_GROUP_ID = 'motorGroup'
const ONLINE_SERVICES_GROUP_ID = 'onlineServicesGroup'
const PRICE_GROUP_ID = 'priceGroup'
const SELLER_GROUP_ID = 'sellerGroup'
const VEHICLE_TYPE_GROUP_ID = 'vehicleTypeGroup'
const YEAR_GROUP_ID = 'yearGroup'
const ENVIRONMENTAL_LABEL_GROUP_ID = 'environmentalLabelGroup'

const ELECTRIC_CHARGING_TIME_GROUP = {
  [ELECTRIC_CHARGING_TIME_GROUP_ID]: [
    FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE,
    FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE
  ]
}

const ADS_LIST_GROUPS = {
  [VEHICLE_TYPE_GROUP_ID]: [FILTER_NAMES.OFFER_TYPE, FILTER_NAMES.CATEGORY_2, FILTER_NAMES.VEHICLE_STATE],
  [MAKE_GROUP_ID]: [FILTER_NAMES.VEHICLES, FILTER_NAMES.MAKE, FILTER_NAMES.MODEL, FILTER_NAMES.VERSION],
  [PRICE_GROUP_ID]: [
    FILTER_NAMES.INSTALMENT,
    FILTER_NAMES.HAS_INSTALMENT,
    FILTER_NAMES.PRICE,
    FILTER_NAMES.PRICE_RANK,
    FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE
  ],
  [ONLINE_SERVICES_GROUP_ID]: [FILTER_NAMES.HAS_RESERVATION, FILTER_NAMES.HAS_ONLINE_FINANCING],
  [LOCATION_GROUP_ID]: [FILTER_NAMES.LOCATION, FILTER_NAMES.PROVINCE, FILTER_NAMES.ONLY_PENINSULA],
  [SELLER_GROUP_ID]: [
    FILTER_NAMES.SELLER_TYPE,
    FILTER_NAMES.RATING,
    FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT,
    FILTER_NAMES.HAS_WARRANTY,
    FILTER_NAMES.IS_CERTIFIED,
    FILTER_NAMES.HAS_STOCK,
    FILTER_NAMES.HAS_PHOTO
  ],
  [YEAR_GROUP_ID]: [FILTER_NAMES.YEAR],
  [KMS_GROUP_ID]: [FILTER_NAMES.KMS],
  [BODY_TYPE_GROUP_ID]: [
    FILTER_NAMES.BODY_TYPE,
    FILTER_NAMES.DOOR,
    FILTER_NAMES.SEAT,
    FILTER_NAMES.LUGGAGE_CAPACITY,
    FILTER_NAMES.BODY_TYPE_CATEGORY
  ],
  [MOTOR_GROUP_ID]: [
    FILTER_NAMES.TRANSMISSION_TYPE,
    FILTER_NAMES.FUEL_TYPE,
    FILTER_NAMES.LITRES,
    FILTER_NAMES.HP,
    FILTER_NAMES.DRIVEN_WHEELS
  ],
  [ENVIRONMENTAL_LABEL_GROUP_ID]: [FILTER_NAMES.ENVIRONMENTAL_LABEL],
  [ELECTRIC_GROUP_ID]: [
    FILTER_NAMES.ELECTRIC_AUTONOMY,
    FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY,
    ELECTRIC_CHARGING_TIME_GROUP_ID
  ],
  [EQUIPMENT_GROUP_ID]: [FILTER_NAMES.EQUIPMENTS],
  [COLOR_GROUP_ID]: [FILTER_NAMES.COLOR]
}

export const FILTERS_GROUPS = {
  ADS_LIST_GROUPS,
  ELECTRIC_CHARGING_TIME_GROUP,
  LOCATION_PLACES_GROUP_ID
}

export const FILTERS_GROUPS_IDS = {
  BODY_TYPE_GROUP_ID,
  COLOR_GROUP_ID,
  ELECTRIC_GROUP_ID,
  ELECTRIC_CHARGING_TIME_GROUP_ID,
  EQUIPMENT_GROUP_ID,
  KMS_GROUP_ID,
  LOCATION_GROUP_ID,
  LOCATION_PLACES_GROUP_ID,
  MAKE_GROUP_ID,
  MOTOR_GROUP_ID,
  ONLINE_SERVICES_GROUP_ID,
  PRICE_GROUP_ID,
  SELLER_GROUP_ID,
  VEHICLE_TYPE_GROUP_ID,
  YEAR_GROUP_ID,
  ENVIRONMENTAL_LABEL_GROUP_ID
}

export const FILTERS_BY_GROUPS_IDS = {
  [ELECTRIC_CHARGING_TIME_GROUP_ID]: [
    FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE,
    FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE
  ],
  [LOCATION_PLACES_GROUP_ID]: [FILTER_NAMES.LOCATION, FILTER_NAMES.PROVINCE]
}
